import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var AutoMetricNode = /*#__PURE__*/function () {
  function AutoMetricNode(type) {
    _classCallCheck(this, AutoMetricNode);
    this.type = type;
    _defineProperty(this, "children", new Set());
    _defineProperty(this, "parent", void 0);
    _defineProperty(this, "fields", new Set());
  }
  _createClass(AutoMetricNode, [{
    key: "attachChild",
    value: function attachChild(node) {
      var _this = this;
      node.parent = this;
      this.children.add(node);

      // detach child callback
      return function () {
        node.parent = undefined;
        _this.children.delete(node);
      };
    }
  }, {
    key: "register",
    value: function register() {
      var _this2 = this;
      for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
        values[_key] = arguments[_key];
      }
      values.forEach(function (value) {
        return _this2.fields.add(value);
      });

      // unregister callback
      return function () {
        values.forEach(function (value) {
          return _this2.fields.delete(value);
        });
      };
    }
  }]);
  return AutoMetricNode;
}();